import { render } from "./GridItem.vue?vue&type=template&id=2d101b90"
import script from "./GridItem.vue?vue&type=script&lang=js"
export * from "./GridItem.vue?vue&type=script&lang=js"

import "./GridItem.vue?vue&type=style&index=0&id=2d101b90&lang=css"

import exportComponent from "C:\\Users\\Daniil\\myProjects\\vueGridLayout\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__